export const ELIGIBLE_DEALERS = [
  {
    dealerName: 'Audi Lakeland',
    dealerId: '05A16',
    rootUrl: 'https://www.audilakeland.com/en/',
    vehicleUrl: 'https://www.audilakeland.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Dallas',
    dealerId: '25A70',
    rootUrl: 'https://www.audidallas.com/en/',
    vehicleUrl: 'https://www.audidallas.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Miami South',
    dealerId: '05A74',
    rootUrl: 'https://www.audimiamisouth.com/en/',
    vehicleUrl: 'https://www.audimiamisouth.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Mohegan Lake',
    dealerId: '08A14',
    rootUrl: 'https://www.audimoheganlake.com/en/',
    vehicleUrl: 'https://www.audimoheganlake.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Marin',
    dealerId: '26A57',
    rootUrl: 'https://www.audimarin.com/en/',
    vehicleUrl: 'https://www.audimarin.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Rancho Mirage',
    dealerId: '22A49',
    rootUrl: 'https://www.audiranchomirage.com/en/',
    vehicleUrl: 'https://www.audiranchomirage.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi State College',
    dealerId: '06A63',
    rootUrl: 'https://www.audistatecollege.com/en/',
    vehicleUrl: 'https://www.audistatecollege.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Seattle',
    dealerId: '23D99',
    rootUrl: 'https://www.audiseattle.com/en/',
    vehicleUrl: 'https://www.audiseattle.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Englewood',
    dealerId: '08B21',
    rootUrl: 'https://www.audienglewood.com/en/',
    vehicleUrl: 'https://www.audienglewood.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi San Juan',
    dealerId: '25A16',
    rootUrl: 'https://www.audisanjuan.com/en/',
    vehicleUrl: 'https://www.audisanjuan.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Albuquerque',
    dealerId: '20D06',
    rootUrl: 'https://www.audiabq.com/en/',
    vehicleUrl: 'https://www.audiabq.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Tacoma',
    dealerId: '23D35',
    rootUrl: 'https://www.auditacoma.com/en/',
    vehicleUrl: 'https://www.auditacoma.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Meadowlands',
    dealerId: '08B54',
    rootUrl: 'https://www.audimeadowlands.com/en/',
    vehicleUrl: 'https://www.audimeadowlands.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Freehold',
    dealerId: '08B03',
    rootUrl: 'https://www.audifreehold.com/en/',
    vehicleUrl: 'https://www.audifreehold.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Allentown',
    dealerId: '06A40',
    rootUrl: 'https://www.audiallentown.com/en/',
    vehicleUrl: 'https://www.audiallentown.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi New Rochelle',
    dealerId: '08A01',
    rootUrl: 'https://www.audinewrochelle.com/en/',
    vehicleUrl: 'https://www.audinewrochelle.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Danbury',
    dealerId: '08C55',
    rootUrl: 'https://www.audidanbury.com/en/',
    vehicleUrl: 'https://www.audidanbury.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Wilmington',
    dealerId: '06B05',
    rootUrl: 'https://www.audiwilmingtonde.com/en/',
    vehicleUrl: 'https://www.audiwilmingtonde.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi North Shore',
    dealerId: '02F21',
    rootUrl: 'https://www.audinorthshore.com/en/',
    vehicleUrl: 'https://www.audinorthshore.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Huntsville',
    dealerId: '07B04',
    rootUrl: 'https://www.audihuntsville.com/en/',
    vehicleUrl: 'https://www.audihuntsville.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Wyoming Valley',
    dealerId: '06A66',
    rootUrl: 'https://www.audiwyomingvalley.com/en/',
    vehicleUrl: 'https://www.audiwyomingvalley.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Mission Viejo',
    dealerId: '22A16',
    rootUrl: 'https://www.audimv.com/en/',
    vehicleUrl: 'https://www.audimv.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Brooklyn',
    dealerId: '08A21',
    rootUrl: 'https://www.audibrooklyn.com/en/',
    vehicleUrl: 'https://www.audibrooklyn.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Lynbrook',
    dealerId: '08A88',
    rootUrl: 'https://www.audilynbrook.com/en/',
    vehicleUrl: 'https://www.audilynbrook.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'The Audi Exchange',
    dealerId: '02A16',
    rootUrl: 'https://www.audiexchange.com/en/',
    vehicleUrl: 'https://www.audiexchange.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Exchange St Charles',
    dealerId: '02A39',
    rootUrl: 'https://www.audiexchangestcharles.com/en/',
    vehicleUrl: 'https://www.audiexchangestcharles.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Exchange Kirkwood',
    dealerId: '24A07',
    rootUrl: 'https://www.audikirkwood.com/en/',
    vehicleUrl: 'https://www.audikirkwood.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Stratham',
    dealerId: '01C07',
    rootUrl: 'https://www.audistratham.com/en/',
    vehicleUrl: 'https://www.audistratham.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Fort Collins',
    dealerId: '20B08',
    rootUrl: 'https://www.audifortcollins.com/en/',
    vehicleUrl: 'https://www.audifortcollins.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Beaverton',
    dealerId: '23A90',
    rootUrl: 'https://www.audibeaverton.com/en/',
    vehicleUrl: 'https://www.audibeaverton.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Nashua',
    dealerId: '01C08',
    rootUrl: 'https://www.audinashua.com/en/',
    vehicleUrl: 'https://www.audinashua.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Gilbert',
    dealerId: '22C10',
    rootUrl: 'https://www.audigilbert.com/en/',
    vehicleUrl: 'https://www.audigilbert.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Manhattan',
    dealerId: '08A85',
    rootUrl: 'https://www.audimanhattan.com/en/',
    vehicleUrl: 'https://www.audimanhattan.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Princeton',
    dealerId: '08B04',
    rootUrl: 'https://www.audiprinceton.com/en/',
    vehicleUrl: 'https://www.audiprinceton.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Flemington',
    dealerId: '08B68',
    rootUrl: 'https://www.audiflemington.com/en/',
    vehicleUrl: 'https://www.audiflemington.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Bakersfield',
    dealerId: '22A05',
    rootUrl: 'https://www.audibakersfield.com/en/',
    vehicleUrl: 'https://www.audibakersfield.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Shawnee Mission',
    dealerId: '24A14',
    rootUrl: 'https://www.audi-shawneemission.com/en/',
    vehicleUrl: 'https://www.audi-shawneemission.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Lafayette',
    dealerId: '25F19',
    rootUrl: 'https://www.audilafayette.com/en/',
    vehicleUrl: 'https://www.audilafayette.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Tri-Cities',
    dealerId: '23D74',
    rootUrl: 'https://www.auditricities.com/en/',
    vehicleUrl: 'https://www.auditricities.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Bay City',
    dealerId: '03C24',
    rootUrl: 'https://www.audibaycity.com/en/',
    vehicleUrl: 'https://www.audibaycity.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Mobile',
    dealerId: '05C18',
    rootUrl: 'https://www.audimobileal.com/en/',
    vehicleUrl: 'https://www.audimobileal.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Clarksburg',
    dealerId: '09E49',
    rootUrl: 'https://www.audiclarksburg.com/en/',
    vehicleUrl: 'https://www.audiclarksburg.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Devon',
    dealerId: '06A08',
    rootUrl: 'https://www.audidevon.com/en/',
    vehicleUrl: 'https://www.audidevon.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Napleton Audi',
    dealerId: '02A30',
    rootUrl: 'https://www.napletonaudi.com/en/',
    vehicleUrl: 'https://www.napletonaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Rochester',
    dealerId: '08A86',
    rootUrl: 'https://www.audirochester.com/en/',
    vehicleUrl: 'https://www.audirochester.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Cape Fear',
    dealerId: '09B30',
    rootUrl: 'https://www.audicapefear.com/en/',
    vehicleUrl: 'https://www.audicapefear.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Hoffman Audi of East Hartford',
    dealerId: '08C10',
    rootUrl: 'https://www.hoffmanaudiofhartford.com/en/',
    vehicleUrl: 'https://www.hoffmanaudiofhartford.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Hoffman Audi of New London',
    dealerId: '08C54',
    rootUrl: 'https://www.hoffmanaudiofnewlondon.com/en/',
    vehicleUrl: 'https://www.hoffmanaudiofnewlondon.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Burlingame',
    dealerId: '26A31',
    rootUrl: 'https://www.audiburlingame.com/en/',
    vehicleUrl: 'https://www.audiburlingame.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Salt Lake City',
    dealerId: '19E02',
    rootUrl: 'https://www.audisaltlakecity.com/en/',
    vehicleUrl: 'https://www.audisaltlakecity.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Prestige Audi',
    dealerId: '20B09',
    rootUrl: 'https://www.prestigeaudi.com/en/',
    vehicleUrl: 'https://www.prestigeaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Thompson',
    dealerId: '01B50',
    rootUrl: 'https://www.thompsonaudi.com/en/',
    vehicleUrl: 'https://www.thompsonaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Gainesville',
    dealerId: '05A53',
    rootUrl: 'https://www.audigainesville.com/en/',
    vehicleUrl: 'https://www.audigainesville.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Sarasota',
    dealerId: '05A47',
    rootUrl: 'https://www.audisarasota.com/en/',
    vehicleUrl: 'https://www.audisarasota.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Boise',
    dealerId: '19B90',
    rootUrl: 'https://www.audiboise.com/en/',
    vehicleUrl: 'https://www.audiboise.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Middleburg Heights',
    dealerId: '03A29',
    rootUrl: 'https://www.audimiddleburgheights.com/en/',
    vehicleUrl: 'https://www.audimiddleburgheights.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Frederick',
    dealerId: '09A13',
    rootUrl: 'https://www.audifrederick.com/en/',
    vehicleUrl: 'https://www.audifrederick.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Elk Grove',
    dealerId: '26A62',
    rootUrl: 'https://www.audielkgrove.com/en/',
    vehicleUrl: 'https://www.audielkgrove.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Richfield',
    dealerId: '02C07',
    rootUrl: 'https://www.audirichfield.com/en/',
    vehicleUrl: 'https://www.audirichfield.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Reading',
    dealerId: '06A39',
    rootUrl: 'https://www.audireading.com/en/',
    vehicleUrl: 'https://www.audireading.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Honolulu',
    dealerId: '21D06',
    rootUrl: 'https://www.audihonolulu.com/en/',
    vehicleUrl: 'https://www.audihonolulu.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Kansas City',
    dealerId: '24A03',
    rootUrl: 'https://www.audikansascity.com/en/',
    vehicleUrl: 'https://www.audikansascity.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Erie',
    dealerId: '06A31',
    rootUrl: 'https://www.audierie.com/en/',
    vehicleUrl: 'https://www.audierie.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Mechanicsburg',
    dealerId: '06A34',
    rootUrl: 'https://www.mechanicsburgaudipa.com/en/',
    vehicleUrl: 'https://www.mechanicsburgaudipa.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Nyack',
    dealerId: '08A92',
    rootUrl: 'https://www.audinyack.com/en/',
    vehicleUrl: 'https://www.audinyack.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Newton',
    dealerId: '08B67',
    rootUrl: 'https://www.audinewton.com/en/',
    vehicleUrl: 'https://www.audinewton.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi West County',
    dealerId: '24A11',
    rootUrl: 'https://www.audiwestcounty.com/en/',
    vehicleUrl: 'https://www.audiwestcounty.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Astorg Audi of Charleston',
    dealerId: '09D19',
    rootUrl: 'https://www.audicharlestonwv.com/en/',
    vehicleUrl: 'https://www.audicharlestonwv.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Arlington',
    dealerId: '09D16',
    rootUrl: 'https://www.audiarlington.com/en/',
    vehicleUrl: 'https://www.audiarlington.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Silver Spring',
    dealerId: '09A09',
    rootUrl: 'https://www.audisilverspring.com/en/',
    vehicleUrl: 'https://www.audisilverspring.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Fiore',
    dealerId: '06A56',
    rootUrl: 'https://www.fioreaudi.com/en/',
    vehicleUrl: 'https://www.fioreaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Bridgewater',
    dealerId: '08B67',
    rootUrl: 'https://www.audibridgewater.com/en/',
    vehicleUrl: 'https://www.audibridgewater.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Arrowhead',
    dealerId: '22C04',
    rootUrl: 'https://www.audiarrowhead.com/en/',
    vehicleUrl: 'https://www.audiarrowhead.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Grand Rapids',
    dealerId: '03C27',
    rootUrl: 'https://www.audigrandrapids.com/en/',
    vehicleUrl: 'https://www.audigrandrapids.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Ann Arbor',
    dealerId: '03C10',
    rootUrl: 'https://www.audiannarbor.com/en/',
    vehicleUrl: 'https://www.audiannarbor.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Jack Daniels Audi of Upper Saddle River',
    dealerId: '08B14',
    rootUrl: 'https://www.jackdanielsusraudi.com/en/',
    vehicleUrl: 'https://www.jackdanielsusraudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Valencia',
    dealerId: '22A53',
    rootUrl: 'https://www.audivalencia.com/en/',
    vehicleUrl: 'https://www.audivalencia.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Temecula',
    dealerId: '22B01',
    rootUrl: 'https://www.auditemecula.com/en/',
    vehicleUrl: 'https://www.auditemecula.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Carlsbad',
    dealerId: '22A72',
    rootUrl: 'https://www.audicarlsbad.com/en/',
    vehicleUrl: 'https://www.audicarlsbad.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Traverse City',
    dealerId: '03C28',
    rootUrl: 'https://www.auditraversecity.com/en/',
    vehicleUrl: 'https://www.auditraversecity.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Shreveport',
    dealerId: '25F17',
    rootUrl: 'https://www.audishreveport.com/en/',
    vehicleUrl: 'https://www.audishreveport.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Natick',
    dealerId: '01A23',
    rootUrl: 'https://www.audinatick.com/en/',
    vehicleUrl: 'https://www.audinatick.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Indianapolis',
    dealerId: '03D20',
    rootUrl: 'https://www.audiindianapolis.com/en/',
    vehicleUrl: 'https://www.audiindianapolis.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Tucson',
    dealerId: '22C08',
    rootUrl: 'https://www.auditucson.com/en/',
    vehicleUrl: 'https://www.auditucson.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Grapevine',
    dealerId: '25A73',
    rootUrl: 'https://www.audigrapevine.com/en/',
    vehicleUrl: 'https://www.audigrapevine.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Sugar Land',
    dealerId: '25A76',
    rootUrl: 'https://www.audisugarland.com/en/',
    vehicleUrl: 'https://www.audisugarland.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Cape Cod',
    dealerId: '01A31',
    rootUrl: 'https://www.audicapecod.com/en/',
    vehicleUrl: 'https://www.audicapecod.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Dayton',
    dealerId: '03A21',
    rootUrl: 'https://www.audidayton.com/en/',
    vehicleUrl: 'https://www.audidayton.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Birmingham',
    dealerId: '03C03',
    rootUrl: 'https://www.audibirminghammi.com/en/',
    vehicleUrl: 'https://www.audibirminghammi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Great Neck',
    dealerId: '08A95',
    rootUrl: 'https://www.audigreatneck.com/en/',
    vehicleUrl: 'https://www.audigreatneck.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Cuyahoga Falls',
    dealerId: '03A09',
    rootUrl: 'https://www.audicuyahogafalls.com/en/',
    vehicleUrl: 'https://www.audicuyahogafalls.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Lansing',
    dealerId: '03C02',
    rootUrl: 'https://www.audilansing.com/en/',
    vehicleUrl: 'https://www.audilansing.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Annapolis',
    dealerId: '09A10',
    rootUrl: 'https://www.audiannapolis.com/en/',
    vehicleUrl: 'https://www.audiannapolis.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Appleton',
    dealerId: '02F56',
    rootUrl: 'https://www.audiappleton.com/en/',
    vehicleUrl: 'https://www.audiappleton.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Mckinney',
    dealerId: '25A77',
    rootUrl: 'https://www.audimckinney.com/en/',
    vehicleUrl: 'https://www.audimckinney.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi North Houston',
    dealerId: '25A06',
    rootUrl: 'https://www.audinorthhouston.com/en/',
    vehicleUrl: 'https://www.audinorthhouston.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Hunt Valley',
    dealerId: '09A02',
    rootUrl: 'https://www.audihuntvalley.com/en/',
    vehicleUrl: 'https://www.audihuntvalley.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Hilton Head',
    dealerId: '07C22',
    rootUrl: 'https://www.audihiltonhead.com/en/',
    vehicleUrl: 'https://www.audihiltonhead.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Baton Rouge',
    dealerId: '25F12',
    rootUrl: 'https://www.audibatonrouge.com/en/',
    vehicleUrl: 'https://www.audibatonrouge.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Albany',
    dealerId: '08A04',
    rootUrl: 'https://www.audialbany.com/en/',
    vehicleUrl: 'https://www.audialbany.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Cincinnati East',
    dealerId: '03A31',
    rootUrl: 'https://www.audicincinnatieast.com/en/',
    vehicleUrl: 'https://www.audicincinnatieast.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Roanoke',
    dealerId: '09D21',
    rootUrl: 'https://www.audiroanoke.com/en/',
    vehicleUrl: 'https://www.audiroanoke.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Morton Grove',
    dealerId: '02A32',
    rootUrl: 'https://www.audimortongrove.com/en/',
    vehicleUrl: 'https://www.audimortongrove.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi of Iowa City',
    dealerId: '02B06',
    rootUrl: 'https://www.carouseliowacityaudi.com/en/',
    vehicleUrl: 'https://www.carouseliowacityaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Queens',
    dealerId: '08A90',
    rootUrl: 'https://www.audiqueens.com/en/',
    vehicleUrl: 'https://www.audiqueens.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Parker',
    dealerId: '20S13',
    rootUrl: 'https://www.audiparker.com/en/',
    vehicleUrl: 'https://www.audiparker.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Orland Park',
    dealerId: '02A37',
    rootUrl: 'https://www.orlandparkaudi.com/en/',
    vehicleUrl: 'https://www.orlandparkaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Madison',
    dealerId: '02F09',
    rootUrl: 'https://www.zimbrickaudiofmadison.com/en/',
    vehicleUrl: 'https://www.zimbrickaudiofmadison.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Washington',
    dealerId: '06A62',
    rootUrl: 'https://www.audiwashington.com/en/',
    vehicleUrl: 'https://www.audiwashington.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Southampton',
    dealerId: '08A37',
    rootUrl: 'https://www.southamptonaudi.com/en/',
    vehicleUrl: 'https://www.southamptonaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi St Paul',
    dealerId: '02C10',
    rootUrl: 'https://www.audistpaul.com/en/',
    vehicleUrl: 'https://www.audistpaul.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Minneapolis',
    dealerId: '02C08',
    rootUrl: 'https://www.audiminneapolis.com/en/',
    vehicleUrl: 'https://www.audiminneapolis.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Falmouth',
    dealerId: '01B01',
    rootUrl: 'https://www.audifalmouth.com/en/',
    vehicleUrl: 'https://www.audifalmouth.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Virginia Beach',
    dealerId: '09D02',
    rootUrl: 'https://www.audivirginiabeach.com/en/',
    vehicleUrl: 'https://www.audivirginiabeach.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Richmond',
    dealerId: '09D17',
    rootUrl: 'https://www.audirichmondva.com/en/',
    vehicleUrl: 'https://www.audirichmondva.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Napa Valley',
    dealerId: '26A69',
    rootUrl: 'https://www.audinapavalley.com/en/',
    vehicleUrl: 'https://www.audinapavalley.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Layton',
    dealerId: '19B01',
    rootUrl: 'https://www.audilayton.com/en/',
    vehicleUrl: 'https://www.audilayton.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Santa Monica Audi',
    dealerId: '22A45',
    rootUrl: 'https://www.santamonicaaudi.com/en/',
    vehicleUrl: 'https://www.santamonicaaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Green Audi',
    dealerId: '02A24',
    rootUrl: 'https://www.greenaudi.com/en/',
    vehicleUrl: 'https://www.greenaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Fort Lauderdale',
    dealerId: '05A72',
    rootUrl: 'https://www.audifortlauderdale.com/en/',
    vehicleUrl: 'https://www.audifortlauderdale.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Pasadena',
    dealerId: '22A22',
    rootUrl: 'https://www.audipasadena.com/en/',
    vehicleUrl: 'https://www.audipasadena.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Rusnak/Westlake',
    dealerId: '22A63',
    rootUrl: 'https://www.audiwestlake.com/en/',
    vehicleUrl: 'https://www.audiwestlake.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Rutland',
    dealerId: '01D54',
    rootUrl: 'https://www.audirutland.com/en/',
    vehicleUrl: 'https://www.audirutland.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Milwaukee',
    dealerId: '02F10',
    rootUrl: 'https://www.milwaukeeaudi.com/en/',
    vehicleUrl: 'https://www.milwaukeeaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Petoskey',
    dealerId: '03C52',
    rootUrl: 'https://www.audipetoskey.com/en/',
    vehicleUrl: 'https://www.audipetoskey.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Muskegon',
    dealerId: '03C54',
    rootUrl: 'https://www.muskegonaudi.com/en/',
    vehicleUrl: 'https://www.muskegonaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Omaha',
    dealerId: '02F02',
    rootUrl: 'https://www.audiomaha.com/en/',
    vehicleUrl: 'https://www.audiomaha.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Naperville',
    dealerId: '02A38',
    rootUrl: 'https://www.napervilleaudi.com/en/',
    vehicleUrl: 'https://www.napervilleaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Bozeman',
    dealerId: '19C79',
    rootUrl: 'https://www.audibozeman.com/en/',
    vehicleUrl: 'https://www.audibozeman.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Denver',
    dealerId: '20B13',
    rootUrl: 'https://www.audidenver.com/en/',
    vehicleUrl: 'https://www.audidenver.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Columbus',
    dealerId: '03A61',
    rootUrl: 'https://www.audicolumbus.com/en/',
    vehicleUrl: 'https://www.audicolumbus.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi West chester',
    dealerId: '06A64',
    rootUrl: 'https://www.audiwestchester.com/en/',
    vehicleUrl: 'https://www.audiwestchester.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Wynnewood',
    dealerId: '06A65',
    rootUrl: 'https://www.audiwynnewood.com/en/',
    vehicleUrl: 'https://www.audiwynnewood.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Montgomery',
    dealerId: '05C10',
    rootUrl: 'https://www.audimontgomery.com/en/',
    vehicleUrl: 'https://www.audimontgomery.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Quad Cities',
    dealerId: '02B11',
    rootUrl: 'https://www.quadcitiesaudi.com/en/',
    vehicleUrl: 'https://www.quadcitiesaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Sioux Falls',
    dealerId: '02E50',
    rootUrl: 'https://www.audisiouxfalls.com/en/',
    vehicleUrl: 'https://www.audisiouxfalls.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Pittsburgh',
    dealerId: '06A61',
    rootUrl: 'https://www.audipittsburgh.com/en/',
    vehicleUrl: 'https://www.audipittsburgh.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Riverside',
    dealerId: '22A28',
    rootUrl: 'https://www.audiriverside.com/en/',
    vehicleUrl: 'https://www.audiriverside.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi North Orlando',
    dealerId: '05A46',
    rootUrl: 'https://www.audinorthorlando.com/en/',
    vehicleUrl: 'https://www.audinorthorlando.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Wilsonvile',
    dealerId: '23A93',
    rootUrl: 'https://www.audiwilsonville.com/en/',
    vehicleUrl: 'https://www.audiwilsonville.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Coral Springs',
    dealerId: '20B11',
    rootUrl: 'https://www.audicoralsprings.com/en/',
    vehicleUrl: 'https://www.audicoralsprings.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Novi',
    dealerId: '03C55',
    rootUrl: 'https://www.audinovi.com/en/',
    vehicleUrl: 'https://www.audinovi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Van Nuys',
    dealerId: '22A18',
    rootUrl: 'https://www.audivannuys.com/en/',
    vehicleUrl: 'https://www.audivannuys.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Calabasas',
    dealerId: '22A34',
    rootUrl: 'https://www.audicalabasas.com/en/',
    vehicleUrl: 'https://www.audicalabasas.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Charleston',
    dealerId: '07C18',
    rootUrl: 'https://www.audicharleston.com/en/',
    vehicleUrl: 'https://www.audicharleston.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Rocklin',
    dealerId: '26A09',
    rootUrl: 'https://www.audirocklin.com/en/',
    vehicleUrl: 'https://www.audirocklin.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Norwell',
    dealerId: '01A27',
    rootUrl: 'https://www.audinorwell.com/en/',
    vehicleUrl: 'https://www.audinorwell.com/en/inventory/vehicle/',
  },
  {
    dealerName: "Darling's Audi",
    dealerId: '01B04',
    rootUrl: 'https://www.darlingsaudi.com/en/',
    vehicleUrl: 'https://www.darlingsaudi.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Pittsfield',
    dealerId: '01A32',
    rootUrl: 'https://www.audipittsfield.com/en/',
    vehicleUrl: 'https://www.audipittsfield.com/en/inventory/vehicle/',
  },
  {
    dealerName: 'Audi Bend',
    dealerId: '23A92',
    rootUrl: 'https://www.audibend.com/en/',
    vehicleUrl: 'https://www.audibend.com/en/inventory/vehicle/',
  },
];

export const ELIGIBLE_DEALER_IDS = ELIGIBLE_DEALERS.map((dealer) => dealer.dealerId);
